import { render } from "./StandingsSunC.vue?vue&type=template&id=67e66e90&scoped=true"
import script from "./StandingsSunC.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsSunC.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsSunC.vue?vue&type=style&index=0&id=67e66e90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e66e90"]])

export default __exports__